import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';

// Toggle Switch Component goes here
const Switch = ({ label, isOn, colorScheme, onChange, size = 'default' }) => {
  const theme = useContext(ThemeContext);

  const sizes = {
    default: {
      buttonSize: 'calc(30px - 4px)',
      height: '30px',
      width: '64px',
    },
    small: {
      buttonSize: 'calc(22px - 4px)',
      height: '22px',
      width: '44px',
    },
  };

  const currentSize = sizes[size] || sizes.default;

  return (
    <>
      <div className="switch">
        <input
          aria-label={label}
          checked={isOn}
          className="switch-checkbox"
          id={label}
          name={label}
          onChange={onChange}
          type="checkbox"
        />

        <label className="switch-label" htmlFor={label}>
          <span className="switch-button" />
        </label>
      </div>
      <style jsx>{`
        .switch-checkbox {
          opacity: 0;
        }
        .switch-label {
          display: flex;
          align-items: center;
          justify-content: space-between;
          box-sizing: content-box;
          cursor: pointer;
          width: ${currentSize.width};
          height: ${currentSize.height};
          margin-top: -10px;
          background-color: ${isOn && colorScheme
            ? colorScheme
            : theme.colors.toggleOffColor};
          border-radius: 100px;
          position: relative;
          transition: background-color 0.2s;
        }

        .switch-label .switch-button {
          content: '';
          position: absolute;
          top: 2px;
          left: 2px;
          width: ${currentSize.buttonSize};
          height: ${currentSize.buttonSize};
          border-radius: 45px;
          transition: 0.2s;
          background-color: ${theme.commoncolors.white};
          box-shadow: 0 0 2px 0 rgba(10, 10, 10, 0.29);
        }

        // Button toggle animation
        .switch-checkbox:checked + .switch-label .switch-button {
          left: calc(100% - 2px);
          transform: translateX(-100%);
        }
        .switch-checkbox:focus + .switch-label {
          outline: 2px solid ${theme.commoncolors.blue};
          outline-offset: 2px;
        }

        .switch-checkbox:focus:not(:focus-visible) + .switch-label {
          outline: 0;
        }
      `}</style>
    </>
  );
};

Switch.propTypes = {
  colorScheme: PropTypes.string,
  isOn: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  size: PropTypes.oneOf(['default', 'small']),
};

export default Switch;
